// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as LeadFlowVm$PorterinFeature from "../../../lead-flow/view/view-model/LeadFlowVm.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as VehicleHelper$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/VehicleHelper.mjs";
import * as TrucksFormCmp$PorterinFeature from "../../../lead-flow/view/component/TrucksFormCmp.mjs";
import * as EstimateLayout$PorterinFeature from "../../../lead-flow/view/component/EstimateLayout.mjs";
import * as LeadFlowBindings$PorterinFeature from "../../../../containers/bindings/LeadFlowBindings.mjs";
import * as TwoWheelerFormCmp$PorterinFeature from "../../../lead-flow/view/component/TwoWheelerFormCmp.mjs";
import * as CategorySelectorCmp$PorterinFeature from "../../../lead-flow/view/component/CategorySelectorCmp.mjs";
import * as SpotEstimateFormCmp$PorterinFeature from "../../../spot-lead-flow/view/SpotEstimateFormCmp.mjs";
import * as EstimateLayoutModuleScss from "../styles/EstimateLayout.module.scss";
import * as SpotEstimateFormLoaderCmp$PorterinFeature from "../../../spot-lead-flow/view/components/SpotEstimateFormLoaderCmp.mjs";
import * as SpotFareEstimateWrapperCmp$PorterinFeature from "../../../lead-flow/view/component/SpotFareEstimateWrapperCmp.mjs";

var styles = EstimateLayoutModuleScss;

function FareEstimateHomeModalCmp(Props) {
  var close_modal = Props.close_modal;
  var category_cards_data = Props.category_cards_data;
  var fare_estimate_form_content = Props.fare_estimate_form_content;
  var modal_content = Props.modal_content;
  var match = React.useState(function () {
        
      });
  var setCategory = match[1];
  var category = match[0];
  var onChangeCategory = function (param) {
    Curry._1(setCategory, (function (param) {
            
          }));
  };
  var match$1 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var query_params = match$1.query_params;
  var onCategorySelect = function (category) {
    var categoryEntity = VehicleHelper$PorterinUtils.getOptionalTypeFromString(category.toLocaleLowerCase());
    var serviceData = category_cards_data.find(function (category_details) {
          return category_details.service_type.toLocaleLowerCase() === category;
        });
    if (categoryEntity !== undefined) {
      var exit = 0;
      switch (categoryEntity) {
        case /* TwoWheelers */0 :
        case /* Trucks */4 :
        case /* Compact */5 :
        case /* Courier */6 :
        case /* PackersMovers */7 :
            exit = 2;
            break;
        case /* Canter3Tonne */1 :
        case /* Pickup1Tonne */2 :
        case /* OneTon7Feet */3 :
        case /* Partload */8 :
            break;
        
      }
      if (exit === 2 && serviceData !== undefined) {
        return JsBindings$PorterinUtils.redirect(serviceData.link + query_params);
      }
      
    }
    Curry._1(setCategory, (function (param) {
            return VehicleHelper$PorterinUtils.getOptionalTypeFromString(category.toLocaleLowerCase());
          }));
  };
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var content_vm = LeadFlowVm$PorterinFeature.getVm(fare_estimate_form_content);
  var fare_estimate_vm = content_vm.fare_estimate_content;
  var spot_fare_estimate_vm = content_vm.spot_fare_estimate_content;
  var match$2 = Router.useRouter();
  var locale = match$2.locale;
  var tmp;
  var exit = 0;
  if (category !== undefined) {
    switch (category) {
      case /* TwoWheelers */0 :
          tmp = React.createElement(EstimateLayout$PorterinFeature.make, {
                title: modal_content.bike_text_subtext.text,
                sub_title: modal_content.bike_text_subtext.sub_text,
                title_mobile: spot_fare_estimate_vm.mobile_modal_content.title,
                sub_title_mobile: undefined,
                children: LocaleHelpers$PorterinUtils.isBkfEnabled(locale, isDesktop) ? React.createElement(LeadFlowBindings$PorterinFeature.GoogleApiLoader.make, {
                        children: React.createElement(SpotFareEstimateWrapperCmp$PorterinFeature.make, {
                              onChangeCategory: onChangeCategory,
                              category_name: modal_content.bike_text_subtext.text,
                              change_label: modal_content.change_label,
                              is_mobile: !isDesktop,
                              serviceCategoryType: /* TwoWheelers */0
                            }),
                        apiKey: Config$PorterinUtils.google_maps_api_key,
                        loader: React.createElement(SpotEstimateFormLoaderCmp$PorterinFeature.make, {})
                      }) : (
                    isDesktop ? React.createElement(TwoWheelerFormCmp$PorterinFeature.make, {
                            onChangeCategory: onChangeCategory,
                            close_modal: close_modal,
                            fare_estimate_vm: fare_estimate_vm,
                            arrow_icon: modal_content.arrow_icon,
                            category_name: modal_content.bike_text_subtext.text,
                            change_label: modal_content.change_label
                          }) : React.createElement(SpotEstimateFormCmp$PorterinFeature.make, {
                            service_category: /* TwoWheelers */0,
                            spot_fare_estimate_vm: spot_fare_estimate_vm
                          })
                  ),
                close_modal: close_modal,
                className: styles["form-container"],
                close_icon: modal_content.close_icon
              });
          break;
      case /* Trucks */4 :
          tmp = React.createElement(EstimateLayout$PorterinFeature.make, {
                title: modal_content.trucks_text_subtext.text,
                sub_title: modal_content.trucks_text_subtext.sub_text,
                title_mobile: spot_fare_estimate_vm.mobile_modal_content.title,
                sub_title_mobile: undefined,
                children: LocaleHelpers$PorterinUtils.isBkfEnabled(locale, isDesktop) ? React.createElement(LeadFlowBindings$PorterinFeature.GoogleApiLoader.make, {
                        children: React.createElement(SpotFareEstimateWrapperCmp$PorterinFeature.make, {
                              onChangeCategory: onChangeCategory,
                              category_name: modal_content.trucks_text_subtext.text,
                              change_label: modal_content.change_label,
                              is_mobile: !isDesktop,
                              serviceCategoryType: /* Trucks */4
                            }),
                        apiKey: Config$PorterinUtils.google_maps_api_key,
                        loader: React.createElement(SpotEstimateFormLoaderCmp$PorterinFeature.make, {})
                      }) : (
                    isDesktop ? React.createElement(TrucksFormCmp$PorterinFeature.make, {
                            onChangeCategory: onChangeCategory,
                            close_modal: close_modal,
                            fare_estimate_vm: fare_estimate_vm,
                            arrow_icon: modal_content.arrow_icon,
                            category_name: modal_content.trucks_text_subtext.text,
                            change_label: modal_content.change_label
                          }) : React.createElement(SpotEstimateFormCmp$PorterinFeature.make, {
                            service_category: /* Trucks */4,
                            spot_fare_estimate_vm: spot_fare_estimate_vm
                          })
                  ),
                close_modal: close_modal,
                className: styles["form-container"],
                close_icon: modal_content.close_icon
              });
          break;
      case /* Compact */5 :
          tmp = React.createElement(EstimateLayout$PorterinFeature.make, {
                title: modal_content.compact_dubai_text_subtext.text,
                sub_title: modal_content.compact_dubai_text_subtext.sub_text,
                title_mobile: spot_fare_estimate_vm.mobile_modal_content.title,
                sub_title_mobile: undefined,
                children: LocaleHelpers$PorterinUtils.isBkfEnabled(locale, isDesktop) ? React.createElement(LeadFlowBindings$PorterinFeature.GoogleApiLoader.make, {
                        children: React.createElement(SpotFareEstimateWrapperCmp$PorterinFeature.make, {
                              onChangeCategory: onChangeCategory,
                              category_name: modal_content.compact_dubai_text_subtext.text,
                              change_label: modal_content.change_label,
                              is_mobile: !isDesktop,
                              serviceCategoryType: /* Compact */5
                            }),
                        apiKey: Config$PorterinUtils.google_maps_api_key,
                        loader: React.createElement(SpotEstimateFormLoaderCmp$PorterinFeature.make, {})
                      }) : (
                    isDesktop ? React.createElement(TrucksFormCmp$PorterinFeature.make, {
                            onChangeCategory: onChangeCategory,
                            close_modal: close_modal,
                            fare_estimate_vm: fare_estimate_vm,
                            arrow_icon: modal_content.arrow_icon,
                            category_name: modal_content.compact_dubai_text_subtext.text,
                            change_label: modal_content.change_label
                          }) : React.createElement(SpotEstimateFormCmp$PorterinFeature.make, {
                            service_category: /* Trucks */4,
                            spot_fare_estimate_vm: spot_fare_estimate_vm
                          })
                  ),
                close_modal: close_modal,
                className: styles["form-container"],
                close_icon: modal_content.close_icon
              });
          break;
      case /* Courier */6 :
          tmp = React.createElement(EstimateLayout$PorterinFeature.make, {
                title: modal_content.courier_text_subtext.text,
                sub_title: modal_content.courier_text_subtext.sub_text,
                title_mobile: spot_fare_estimate_vm.mobile_modal_content.title,
                sub_title_mobile: undefined,
                children: isDesktop ? React.createElement(TwoWheelerFormCmp$PorterinFeature.make, {
                        onChangeCategory: onChangeCategory,
                        close_modal: close_modal,
                        fare_estimate_vm: fare_estimate_vm,
                        arrow_icon: modal_content.arrow_icon,
                        category_name: modal_content.bike_text_subtext.text,
                        change_label: modal_content.change_label
                      }) : React.createElement(SpotEstimateFormCmp$PorterinFeature.make, {
                        service_category: /* TwoWheelers */0,
                        spot_fare_estimate_vm: spot_fare_estimate_vm
                      }),
                close_modal: close_modal,
                className: styles["form-container"],
                close_icon: modal_content.close_icon
              });
          break;
      case /* Canter3Tonne */1 :
      case /* Pickup1Tonne */2 :
      case /* OneTon7Feet */3 :
      case /* PackersMovers */7 :
      case /* Partload */8 :
          exit = 1;
          break;
      
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(EstimateLayout$PorterinFeature.make, {
          title: modal_content.modal_text_subtext.text,
          sub_title: modal_content.modal_text_subtext.sub_text,
          title_mobile: modal_content.modal_text_subtext_mobile.text,
          sub_title_mobile: modal_content.modal_text_subtext_mobile.sub_text,
          children: React.createElement(CategorySelectorCmp$PorterinFeature.make, {
                onCategorySelect: onCategorySelect,
                category_cards_data: category_cards_data,
                arrow_icon: modal_content.arrow_icon
              }),
          close_modal: close_modal,
          close_icon: modal_content.close_icon
        });
  }
  return React.createElement("div", undefined, tmp);
}

var make = FareEstimateHomeModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
